/**
 * @generated SignedSource<<6b739c3cd15aee022568dfc0e0e91f46>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appointmentSearch_WaitingRoomAppointment$data = {
  readonly appointment: {
    readonly appointmentId: number;
    readonly id: string;
    readonly patient: {
      readonly birthDate: any;
      readonly displayId: number;
      readonly firstName: string;
      readonly id: string;
      readonly lastName: string;
      readonly patientId: string;
    };
    readonly reason: string;
  };
  readonly " $fragmentType": "appointmentSearch_WaitingRoomAppointment";
};
export type appointmentSearch_WaitingRoomAppointment$key = {
  readonly " $data"?: appointmentSearch_WaitingRoomAppointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentSearch_WaitingRoomAppointment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appointmentSearch_WaitingRoomAppointment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Appointment",
      "kind": "LinkedField",
      "name": "appointment",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "appointmentId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "patient",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "patientId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "firstName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "lastName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "birthDate",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WaitingRoomAppointment",
  "abstractKey": null
};
})();

(node as any).hash = "3b9c8601eb9703abe64bbcd176a487d5";

export default node;
